<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.recommendedListing') }}</b>
    </h3>
    <hr />
    <h3>
      <b>22.1 Book Fitur Listing Rekomendasi melalui Aplikasi Mobile (iOS/Android)</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih tombol “Listing Rekomendasi” di bagian toolbar halaman utama.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-1.jpg"
            alt="Tombol Listing Rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
      <br />
      <li>
        Selanjutnya akan muncul halaman listing rekomendasi. Klik “Tambah Listing” atau “Listing
        Saya” untuk memilih listing yang akan anda jadikan Listing Rekomendasi.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-2.jpg"
            alt="Halaman listing rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
      <br />
      <li>
        Di halaman listing, silahkan pilih listing terbaik anda untuk dijadikan listing rekomendasi,
        lalu klik tombol “Listing Rekomendasi”.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-3.jpg"
            alt="Memilih listing rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
      <br />
      <li>
        Akan muncul halaman keterangan detail perihal listing yang anda pilih untuk memastikan
        lokasi dan detail listing sudah benar.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-4.jpg"
            alt="Detail listing rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
      <br />
      <li>
        Scroll ke bawah dan pilih tanggal tayang yang anda inginkan. Tanggal tayang tersedia untuk 8
        minggu ke depan jika anda ingin menggunakan Fitur Listing Rekomendasi untuk beberapa
        periode. Lalu klik tombol “Pasang Listing Rekomendasi” jika anda sudah setuju dengan
        persyaratan yang ada.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-5.jpg"
            alt="Memilih tanggal tayang listing rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
      <br />
      <li>
        Akan muncul halaman konfirmasi untuk memastikan listing yang anda pilih akan dinaikkan
        sebagai Listing Rekomendasi.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-6.jpg"
            alt="Konfirmasi listing rekomendasi di aplikasi mobile"
          />
        </div>
      </li>
    </ul>
    <hr />
    <h3>
      <b>22.2 Book Fitur Listing Rekomendasi melalui Browser Laptop/PC</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih menu “Listing Rekomendasi” di bagian toolbar halaman utama dan klik tombol “Pasang
        Listing Rekomendasi”.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-7.jpg"
            alt="Menu Listing Rekomendasi di browser"
          />
        </div>
      </li>
      <br />
      <li>
        Selanjutnya akan muncul halaman listing untuk anda pilih salah satu listing terbaik anda,
        lalu klik tombol “Listing Rekomendasi”.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-8.jpg"
            alt="Memilih listing rekomendasi di browser"
          />
        </div>
      </li>
      <br />
      <li>
        Akan muncul tab keterangan detail perihal listing yang anda pilih untuk memastikan lokasi
        dan detail listing sudah benar.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-9.jpg"
            alt="Detail listing rekomendasi di browser"
          />
        </div>
      </li>
      <br />
      <li>
        Scroll ke bawah dan pilih tanggal tayang yang anda inginkan. Tanggal tayang tersedia untuk 8
        minggu ke depan jika anda ingin menggunakan Fitur Listing Rekomendasi untuk beberapa
        periode.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-10.jpg"
            alt="Memilih tanggal tayang listing rekomendasi di browser"
          />
        </div>
      </li>
      <br />
      <li>
        Tekan tombol “Pasang Listing Rekomendasi” jika anda sudah setuju dengan persyaratan yang
        ada.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/listing-rekomendasi-11.jpg"
            alt="Memasang listing rekomendasi di browser"
          />
        </div>
      </li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'RecommendedListing',
};
</script>

<style></style>
